export enum OpenSidebar {
    updateTags,
    addTags,
    renameTags,
    changeTagValues,
    removeTags,
    copyTags,
    undefined,
}
